import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { useDescargarPdfInvestigacionVisitaMutation } from '../../../services/visitasApi';
import { CommonMimeType, downloadBase64File } from '../../../utils/base64FileDownload';

// PDF de investigacion desde la visita (SMP-401). Recibe la visita al descargar porque en la grilla
// cambia segun la fila; quien lo usa decide si mostrar la accion (puedeDescargarPdfInvestigacion).
export const useDescargaPdfInvestigacionVisita = () => {
    const { t } = useTranslation('visitas');
    const [descargarPdf] = useDescargarPdfInvestigacionVisitaMutation();
    const [descargandoPdfInvestigacion, setDescargandoPdfInvestigacion] = useState(false);

    const descargarPdfInvestigacion = async (visita: any) => {
        if (descargandoPdfInvestigacion || !visita?.id) return;

        setDescargandoPdfInvestigacion(true);
        try {
            const pdfBase64 = await descargarPdf(visita.id).unwrap();

            // Sin PDF en la respuesta no se descarga nada: ni vacio ni corrompido.
            if (!pdfBase64) throw new Error('PDF sin contenido');

            downloadBase64File({
                base64Data: pdfBase64,
                fileName: `investigacion-${visita.siniestro?.id}.pdf`,
                mimeType: CommonMimeType.PDF
            });
        } catch {
            enqueueSnackbar(t('alerts.downloadPdfInvestigacion.error'), { variant: 'error' });
        } finally {
            setDescargandoPdfInvestigacion(false);
        }
    };

    return { descargandoPdfInvestigacion, descargarPdfInvestigacion };
};
